import cn from "classnames";
import { Container } from "react-bootstrap";

export const Divider = ({ className }) => {
  return (
    <div className={cn(className)}>
      <Container className="mw-xxl">
        <hr />
      </Container>
    </div>
  );
};

export default Divider;
